import { useCallback } from 'react';
import { useAuthContext } from '../internal/AuthContext';
export function useGetIsScoped() {
  const {
    scopes
  } = useAuthContext();
  return useCallback(scope => scopes.has(scope), [scopes]);
}